<template>
  <div id="center">
    <div class="up">
      <div
        class="bg-color-black item"
        v-for="item in titleItem"
        :key="item.title"
      >
        <p class="ml-3 colorBlue fw-b ">{{ item.title }}</p>
        <div>
          <div>
                    <p class="value">
                      {{ item.number }}<span class="unit">{{ item.unit }}</span>
                    </p>
                  </div>
        </div>
      </div>
    </div>
    <div class="down">
      <div class="ranking bg-color-black">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class=" text mx-2 mb-1 pl-3">科室当日耗水排行</span>
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking" />
      </div>
       <div class="ranking bg-color-black">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <span class=" text mx-2 mb-1 pl-3">科室当日耗电排行</span>
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking2" />
      </div>
    </div>
  </div>
</template>

<script>
//import CenterChart from '@/components/echart/center/centerChartRate'

export default {
  data() {
    return {
      titleItem: [
        {
          title: '今日耗水',
          number: 420.0,
          unit: 't'
        },
        {
          title: '今日耗电',
          number: 7109.0,
          unit: 'kwh'
        },
        {
          title: '今日耗汽',
          number: 900,
          unit: 'm³'
        },
        {
          title: '今年耗水',
          number: 12784.5,
          unit: 't'
        },
        {
          title: '今年耗电',
          number: 23635.7,
          unit: 'kwh'
        },
        {
          title: '今年耗气',
          number: 3689.4,
          unit: 'm³'
        }
      ],
      ranking: {
        data: [
          {
            name: '消化内科',
            value: 8
          },
          {
            name: '呼吸科',
            value: 5
          },
          {
            name: '普外科',
            value: 3
          },
          {
            name: '泌尿外科',
            value: 7
          },
          {
            name: '妇产科',
            value: 15
          },
          {
            name: '儿科',
            value: 9
          },
          {
            name: '肿瘤科',
            value: 12
          },
          {
            name: '烧伤科',
            value: 21
          },
          {
            name: '口腔科',
            value: 14
          },
          {
            name: '血液科',
            value: 28
          }
        ],
        carousel: 'single',
        unit: '吨'
      },
     ranking2: {
        data: [
          {
            name: '消化内科',
            value: 150
          },
          {
            name: '呼吸科',
            value: 187
          },
          {
            name: '普外科',
            value: 232
          },
          {
            name: '泌尿外科',
            value: 90
          },
          {
            name: '妇产科',
            value: 148
          },
          {
            name: '儿科',
            value: 138
          },
          {
            name: '肿瘤科',
            value: 238
          },
          {
            name: '烧伤科',
            value: 259
          },
          {
            name: '口腔科',
            value: 174
          },
          {
            name: '血液科',
            value: 130
          }
        ],
        carousel: 'single',
        unit: 'kwh'
      }
    }
  },
  components: {
    
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      text-align: center;
      width: 32%;
      height: 70px;
     .value {
      color: #fff;
      font-size: 25px;
      font-weight: 600;
      text-align: center;
      vertical-align: middle;
      margin-top: 10px;
    }
    .label {
      margin-top: 35px;
    }
    .unit,
    .label {
      font-size: 18px;
      color: #fff;
    }
    .unit {
      margin-left: 6px;
      font-weight: 400;
    }
   
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 255px;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 59%;
      .dv-scr-rank-board {
        height: 225px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
